export default __webpack_public_path__ + "static/banner-telecom-dcc6e131502d4cc6cabfbb0db2054aa7.webp";